// grabs the boardId from the columns combinedId
export const boardIdFromColumnId = (id: string): string | null => {
  if (id.indexOf(':') === -1) {
    return null;
  }

  const split0 = id.split(':')[0];

  if (split0.trim().length === 0) {
    return null;
  }

  return split0;
};
